import type { Pathways_StackingType as StackingType } from '__generated__/graphql-types';

import { getUpsellCopy } from 'bundles/stackability-common/stackability-common-index';

/**
 * @description Used ot get the correct caption for the pathway degree upsell
 */
const getPathwayUpsellCaption = (degreeStackingType: StackingType) => {
  const upsellCopy = getUpsellCopy().homepagesNavXdp;
  switch (degreeStackingType) {
    case 'PART_OF':
      return upsellCopy.buildTowardADegree;
    case 'OFFERS_CREDIT':
      return upsellCopy.earnDegreeCredit;
    default:
      return upsellCopy.prepareForADegree;
  }
};

export default getPathwayUpsellCaption;
